<template>
	<div :class="'configuration-panel animated fast fadeIn'">

		<div class="configuration-panel-body" v-if="!installStatus.success">
			<form @submit="installItem" action="javascript:void(0);">
				<section>
					<header class="configuration-panel-header">
						<h1 class="header-title">Setup </h1>
						<span class="header-actions">
							<button type="button" class="link" @click="requestClose">
								<i class="fas fa-times fa-lg"></i>
							</button>
						</span>
					</header>
					<section>
						<div class="input-group">
							<label>Give this integration a name{{selectedItem.uiOptions.nameRequired ? '*' : ''}}</label>
							<input type="text" v-model="name" :placeholder="'Default:' + selectedItem.name" :required="selectedItem.uiOptions.nameRequired">
						</div>
						<templateOptions :options="selectedItem.templateOptions" :updateFunction="updateTemplateOptionsValue" :installContext=installContext></templateOptions>
					</section>
				</section>
				<section>
					<header class="configuration-panel-header">
						<h1 class="header-title">Choose a Bucket</h1>
					</header>
					<section>
						<div class="bucket-option">
							<div class="input-group">
								<label v-if="!selectedItem.uiOptions.createNewBucketDisabled" for="new" class="radio"><input type="radio" id="new" value="new" v-model="bucketOptionType"> Create a new bucket</label>
								<label for="existing" class="radio"><input type="radio" id="existing" value="existing" v-model="bucketOptionType"> Send data to an existing bucket</label>
							</div>
						</div>
						<div class="bucket-info option">
							<div v-if="bucketOptionType == 'new'" class="input-group">
								<label>Initial State Access Key
									<small><a href="https://support.initialstate.com/hc/en-us/articles/360002911931-Finding-an-Access-Key" target="_blank"> What's this?</a>
									</small>
								</label>
								<select v-model="selectedAccessKey" required>
									<option disabled value=''>Choose an Access Key </option>
									<option v-for="key in activeKeys" v-bind:value="key" v-bind:key=key>
										{{ key }}
									</option>
								</select>
								<!-- <div>
									<div class="input-group">
										<label>Initial State Bucket Key</label>
										<input type="text" v-model="bucketKey" placeholder="Optional">
									</div>
								</div> -->
							</div>
							<div v-if="bucketOptionType == 'existing'" class="input-group" >
								<label></label>
								<select v-model="selectedBucket" required>
									<option disabled value=''>Select a Bucket</option>
									<option v-for="bucket in buckets" v-bind:value="bucket" v-bind:key=bucket.id>
										{{ bucket.name }}
									</option>
								</select>
							</div>
						</div>
					</section>
				</section>
				<section v-if="!selectedItem.uiOptions.signalSelectionDisabled">
					<header class="configuration-panel-header">
						<h1 class="header-title">What data would you like?</h1>
					</header>
					<section>
						<div class="input-group">
							<label class="radio"><input type="radio" id="all" name="dataToUse" value="all" v-model="useSignals"> All available data  </label>
							<label class="radio"><input type="radio" id="selection" name="dataToUse" value="some" v-model="useSignals"> I want to select specific data</label>
						</div>
						<section v-if="useSignals == 'some'">
							<div class="input-group" v-for="signal in sortedSignalOptions" :key="signal.name || signal.group">
								<label><input type="checkbox" v-model="selectedSignals" :value="signal.name || signal"/>{{signal.name || signal.group}}</label>
							</div>
						</section>
					</section>
				</section>
				<section>
					<header class="configuration-panel-header">
						<h1 class="header-title">How often do you want new data?</h1>
					</header>
					<section>
						<header class="input-columns">
							<div >Interval</div>
							<div>Credits Needed</div>
						</header>
						<div class="input-columns" v-for="(option, idx) in selectedItem.cronSelections" v-bind:key="option.cronExpr">
							<div class="input-group" >
								<label :for="idx" class="radio"><input type="radio" :id="idx" v-bind:value="option" v-model="selectedCron">{{selectedItem.cronReadable(option.cronExpr)}} </label>
							</div>
							<div><span class="token"></span> {{option.cost}}</div>
						</div>
					</section>
				</section>
				<section>
					<button type="submit" class="outline-btn call-to-action" :disabled="installStatus.loading">Start Integration<spinner v-if="installStatus.loading" hideText="true"></spinner></button>
					<button type="submit" class="outline-btn visible-xs visible-sm" :disabled="installStatus.loading" @click="requestClose">Quit</button>
				</section>
			</form>
			<FailMessage  v-if="installStatus.error" title="We could not start this Integration">
				<p v-if="installStatus.errorMessage">{{ installStatus.errorMessage }}</p>
				<p v-else>
					Your integration could not be started. Try again, or <a href="https://support.initialstate.com/hc/en-us/requests/new" target="_blank"> contact us </a> for help!
				</p>
			</FailMessage>
		</div>
		<div v-if="installStatus.success" class="text-center success-message">
			<div>
				<AnimatedLogo></AnimatedLogo>
			</div>
			<h3>Your Integration Has Started!</h3>
			<p><a :href="getIotURL()" class="outline-btn call-to-action" target="_blank">View in the IoT App</a></p>
			<ul class="success-links">
				<li>
					<router-link :to="{name: 'marketplace'}" class="arrow-link" >
						Browse More Integrations
					</router-link>
				</li>
				<li>
					<router-link :to="{name: 'manage'}" class="arrow-link" >
						Go To Your Installed Integrations
					</router-link>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Spinner from './Spinner';
import TemplateOptions from './TemplateOptions';
import FailMessage from './FailMessage';
import AnimatedLogo from './AnimatedLogo';
import { validateTemplateOptions } from '../utils/validator';


export default {
	name: 'ItemInstall',
	components: {
		Spinner,
		TemplateOptions,
		FailMessage,
		AnimatedLogo,
	},
	data () {
		return {
			fadeOut: false,
			selectedAccessKey: '',
			bucketKey: '',
			bucketOptionType: 'new',
			useSignals: 'all',
			selectedSignals: [],
			selectedBucket: '',
			selectedCron: null,
			name: ''
		};
	},
	computed: {
		...mapGetters([
			'appURL',
			'buckets',
			'selectedItem',
			'installStatus',
			'installContext',
			'installedPolls',
			'createAccessKeyStatus',
			'roles',
			'activeKeys',
			'user',
			'credits',
		]),
		sortedSignalOptions() {
			return [...this.selectedItem.signalOptions].sort((a,b) => {
				// uppercase to ignore casing
				const itemA = (a.name || a.group).toUpperCase();
				const itemB = (b.name || b.group).toUpperCase();

				let comparison = 0;
				if (itemA > itemB) {
					comparison = 1;
				} else if (itemA < itemB) {
					comparison = -1;
				}
				return comparison;
			});
		}
	},
	methods: {
		requestClose: function () {
			this.$emit('close');
		},
		updateTemplateOptionsValue (eventOrValue, templateOption, templateOptionListIndex) {
			this.$store.dispatch('UPDATE_TEMPLATE_OPTIONS_VALUE', { eventOrValue, templateOption, templateOptionListIndex });
		},
		installItem() {
			if (!validateTemplateOptions(this.selectedItem.templateOptions)) {
				return;
			}

			let bucketKey = null;
			let accessKey = null;
			let selectedBucketId = null;
			let createBucket = false;
			if (this.bucketOptionType === 'new') {
				accessKey = this.selectedAccessKey;
				bucketKey = this.bucketKey;
				createBucket = true;
			} else if (this.bucketOptionType === 'existing' && this.selectedBucket) {
				accessKey = this.selectedBucket.accessKey;
				bucketKey = this.selectedBucket.bucketKey;
				selectedBucketId = this.selectedBucket.id;
			}
			let payload = {
				itemId: this.selectedItem.id,
				name: this.name,
				accessKey,
				bucketKey,
				selectedBucketId,
				createBucket,
				cron: this.selectedCron ? this.selectedCron.cronExpr : null,
				templateValues: this.selectedItem.templateOptions,
			};
			if (this.useSignals === 'some') {
				payload.selectedSignals = this.selectedSignals;
			}

			if (this.selectedCron && this.selectedCron.cost) {
				// make sure user has enough credits
				let cost = this.selectedCron.cost;
				let remainingCredits = this.credits.remaining || 0;
				if (cost > remainingCredits) {
					this.$store.dispatch('SET_ITEM_INSTALL_ERROR', 'Not enough credits.');
					return;
				}
			}
			this.$store.dispatch('ITEM_INSTALL_REQUEST', payload);
		},
		getIotURL() {
			let bucketId;
			if (this.installStatus && this.installStatus.newBucketId) {
				bucketId = this.installStatus.newBucketId;
			} else if (this.selectedBucket && this.selectedBucket.id) {
				bucketId = this.selectedBucket.id;
			}
			return bucketId ? this.appURL + `&destination=/tiles/${bucketId}` :  this.appURL;
		},
	},
	created() {
		this.$store.dispatch('RESET_ITEM_INSTALL');
		this.$store.dispatch('LIST_BUCKETS_REQUEST');

		// pre-select the default cron option
		let defaultCronExpr = this.selectedItem.template.cron;
		this.selectedCron = this.selectedItem.cronSelections.find(selection => selection.cronExpr === defaultCronExpr);

		// pre-select access key
		this.selectedAccessKey = (this.activeKeys && this.activeKeys.length) ? this.activeKeys[0] : '';

		// pre-select bucket option type
		if (this.selectedItem.uiOptions && this.selectedItem.uiOptions.createNewBucketDisabled) {
			this.bucketOptionType = 'existing';
		}
	}
};
</script>

<style scoped>
	.success-message{
		background-color: #edf0f3;
		/* background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='208' height='208' viewBox='0 0 800 800'%3E%3Cg fill='none' stroke='%23aec9d4' stroke-width='2'%3E%3Cpath d='M769 229L1037 260.9M927 880L731 737 520 660 309 538 40 599 295 764 126.5 879.5 40 599-197 493 102 382-31 229 126.5 79.5-69-63'/%3E%3Cpath d='M-31 229L237 261 390 382 603 493 308.5 537.5 101.5 381.5M370 905L295 764'/%3E%3Cpath d='M520 660L578 842 731 737 840 599 603 493 520 660 295 764 309 538 390 382 539 269 769 229 577.5 41.5 370 105 295 -36 126.5 79.5 237 261 102 382 40 599 -69 737 127 880'/%3E%3Cpath d='M520-140L578.5 42.5 731-63M603 493L539 269 237 261 370 105M902 382L539 269M390 382L102 382'/%3E%3Cpath d='M-222 42L126.5 79.5 370 105 539 269 577.5 41.5 927 80 769 229 902 382 603 493 731 737M295-36L577.5 41.5M578 842L295 764M40-201L127 80M102 382L-261 269'/%3E%3C/g%3E%3Cg fill='%23aec9d4'%3E%3Ccircle cx='769' cy='229' r='8'/%3E%3Ccircle cx='539' cy='269' r='8'/%3E%3Ccircle cx='603' cy='493' r='8'/%3E%3Ccircle cx='731' cy='737' r='8'/%3E%3Ccircle cx='520' cy='660' r='8'/%3E%3Ccircle cx='309' cy='538' r='8'/%3E%3Ccircle cx='295' cy='764' r='8'/%3E%3Ccircle cx='40' cy='599' r='8'/%3E%3Ccircle cx='102' cy='382' r='8'/%3E%3Ccircle cx='127' cy='80' r='8'/%3E%3Ccircle cx='370' cy='105' r='8'/%3E%3Ccircle cx='578' cy='42' r='8'/%3E%3Ccircle cx='237' cy='261' r='8'/%3E%3Ccircle cx='390' cy='382' r='8'/%3E%3C/g%3E%3C/svg%3E"); */
	}
	.configuration-panel form > section{
		padding: 12px 15px;
		border-bottom: 1px solid #fff;
		margin-bottom:10px;
	}

	.configuration-panel form > section:last-of-type{

		border-bottom: none;

	}

	.header-actions{
		position: relative;
		top:-12px;
	}
	.configuration-panel-header {
		margin-bottom:10px;
		flex: 0 0 auto;
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.input-columns{
		display:flex;
		align-items: baseline;
		justify-content: space-between
	}

	header.input-columns {
		padding: 10px 0;
		text-align: center;
	}
	.input-columns > div:last-of-type{
		margin-right: 40%;
	}

	.input-columns .input-group{
		margin: 7px 0;
	}
	.outline-btn:hover .loading{
		color: white;
	}
	.outline-btn .loading{
		color: #337CCA;
		margin-left: 5px;
		display:inline-block;
		padding:0;
	}

	.success-links li{
		list-style: none;
		margin: 10px auto;
	}
	.configuration-panel {
		border-left: 1px solid #f1f3f6;
		padding: 10px 0;
		background-color: #EDF0F3;
		background-repeat: repeat;
		height: auto;
		height:100%;
		overflow: auto;
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		box-shadow: -2px 5px 20px -12px #e3e6ea;
	}
	.header-title {
		flex: 1 1 auto;
		font-size: 1.2em;
		margin: 0;
	}
	.header-actions {
		flex: 0 0 auto;
	}
	.input-group small{
		margin-left:5px;
	}

	@-webkit-keyframes fadeIn {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	.fadeIn {
		-webkit-animation-name: fadeIn;
		animation-name: fadeIn;
	}

	.animated {
		-webkit-animation-duration: 1s;
		animation-duration: 1s;
		-webkit-animation-fill-mode: both;
		animation-fill-mode: both;
	}

	.animated.fast {
		-webkit-animation-duration: 400ms;
		animation-duration: 400ms;
	}

	@media (print), (prefers-reduced-motion: reduce) {
		.animated {
			-webkit-animation-duration: 1ms !important;
			animation-duration: 1ms !important;
			-webkit-transition-duration: 1ms !important;
			transition-duration: 1ms !important;
			-webkit-animation-iteration-count: 1 !important;
			animation-iteration-count: 1 !important;
		}
	}

	@-webkit-keyframes fadeOut {
		from {
			opacity: 1;
		}

		to {
			opacity: 0;
		}
	}

	@keyframes fadeOut {
		from {
			opacity: 1;
		}

		to {
			opacity: 0;
		}
	}

	.fadeOut {
		-webkit-animation-name: fadeOut;
		animation-name: fadeOut;
	}

	@-webkit-keyframes fadeInDown {
		from {
			opacity: 0;
			-webkit-transform: translate3d(0, -100%, 0);
			transform: translate3d(0, -100%, 0);
		}

		to {
			opacity: 1;
			-webkit-transform: translate3d(0, 0, 0);
			transform: translate3d(0, 0, 0);
		}
	}

	@keyframes fadeInDown {
		from {
			opacity: 0;
			-webkit-transform: translate3d(0, -100%, 0);
			transform: translate3d(0, -100%, 0);
		}

		to {
			opacity: 1;
			-webkit-transform: translate3d(0, 0, 0);
			transform: translate3d(0, 0, 0);
		}
	}


	@-webkit-keyframes fadeOut {
		from {
			opacity: 1;
		}

		to {
			opacity: 0;
		}
	}

	@keyframes fadeOut {
		from {
			opacity: 1;
		}

		to {
			opacity: 0;
		}
	}

	.fadeOut {
		-webkit-animation-name: fadeOut;
		animation-name: fadeOut;
	}

	label{
		display: block;
	}

	.input-group{
		margin: 15px auto;
	}

	.input-group input[type = radio],
	.input-group input[type = checkbox]{
		vertical-align: middle;
		margin-right:5px;
	}

	.input-group input[type = text],
	.input-group select {
		display:block;
		width:100%;

	}
	.input-helper{
		margin: 0 0 15px;
		font-size:12px;
		color: #555;
	}
	label.radio{
		margin-bottom: 5px;
	}

	.success-message{
		display: flex;
		flex-direction: column;
		height: 100%;
		padding-top:25px;
	}

	.success-message svg{
		margin: 25px auto;
	}


	/* // Extra small devices (portrait phones, less than 576px) */
	@media (max-width: 575.98px) {
		.configuration-panel{
			margin-left: 0;
		}


		}

	/* // Small devices (landscape phones, 576px and up) */
	@media (min-width: 576px) and (max-width: 767.98px) {

	.configuration-panel{
		margin-left: 0;
	}
	}


	/* // Medium devices (tablets, 768px and up) */
	@media (min-width: 768px) and (max-width: 991.98px) {
		.visible-xs, .visible-sm{
			display:none;
		}
	}

	/* // Large devices (desktops, 992px and up) */
	@media (min-width: 992px) and (max-width: 1199.98px) {
		.visible-xs, .visible-sm{
			display:none;
		}
	}

	/* // Extra large devices (large desktops, 1200px and up) */
	@media (min-width: 1200px) {
		.visible-xs, .visible-sm{
			display:none;
		}

	}
</style>



// WEBPACK FOOTER //
// src/components/ItemInstall.vue